import { serviceTwoFA } from 'services';
import { TAsyncStatesHandlers } from 'hooks/use-mutation-hook-wrapper';
import { twoFA as types, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';

const useGet2fa = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<types.TTwoFA>, string>,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<types.TTwoFA>,
        string,
        null
    >({
        queryKey: 'generateTwoFA',
        queryFn: serviceTwoFA.generate,
        queryConfig: arg0,
        values: null,
    });
};

export default useGet2fa;
